import { get } from 'lodash';

export const getNestedProperty = (path, nestedObj, defaultValue = null) => {
  return get(nestedObj, path, defaultValue);
};
